// extracted by mini-css-extract-plugin
export var addToCartWrapper = "_q5-8";
export var editMode = "_q5-3";
export var headerRow = "_q5-a";
export var headerTitle = "_q5-b";
export var product = "_q5-1";
export var productDetails = "_q5-5";
export var productDivider = "_q5-7";
export var productImage = "_q5-2";
export var productInfo = "_q5-4";
export var productTitle = "_q5-6";
export var strikethrough = "_q5-9";
export var upsellProductsCard = "_q5-0";